module.exports = __webpack_public_path__ + "img/banner-bg.57bd9d81.png";